<template>
	<el-icon :size="size" :color="color">
		<component :is="icon"/>
	</el-icon>
</template>

<script setup>
const props = defineProps({
	icon: {
		type: String,
		required: true,
	},
	size: {
		type: String
	},
	color: {
		type: String
	}
})
</script>

<style scoped>

</style>
